import { atom } from 'recoil';
import { OperationsListType } from '../types/OperationTypes';

export const OperationsListState = atom<OperationsListType>({
  key: 'OperationsListState',
  default: {
    list: null,
  },
});
